import React, { ChangeEvent } from "react"
import { constants } from "@albelli/photoselector"
import photoImage from "@albelli/photoselector/lib/ImagePicker/Graphic/photos.svg"

const SizeSlider = (props: any) => {
  const { store } = props
  const layoutId = store.getLayoutId()

  const itemSize = store.getItemSize()

  const setItemSize = (event: ChangeEvent<HTMLInputElement>) => {
    store.setItemSize(Number(event.target.value))
  }

  const shrinkItemSize = () => {
    if (itemSize !== 120) {
      store.setItemSize(itemSize - 100)
    }
  }

  const enlargeItemSize = () => {
    if (itemSize !== 320) {
      store.setItemSize(itemSize + 100)
    }
  }

  return window.innerWidth > constants.mobileWidth ? (
    <div className="photoselector-image-size-slider-container" data-tam="image-size-slider-container">
      <img onClick={shrinkItemSize} className="photoselector-image-size-slider-icon-small" data-tam="image-size-slider-small" src={photoImage} />
      <input
        hidden={layoutId !== "flex" && layoutId !== "square"}
        value={itemSize}
        onChange={setItemSize}
        type="range"
        min="120"
        max="320"
        step="100"
        data-tam="image-size-slider"
        className="photoselector-image-size-slider"
      ></input>
      <img onClick={enlargeItemSize} className="photoselector-image-size-slider-icon-big" data-tam="image-size-slider-big" src={photoImage} />
    </div>
  ) : null
}

export default SizeSlider
